initSectionIngredients();
function initSectionIngredients() {
  const modules = document.querySelectorAll(".sc-ingredients");
  let isMobile = window.innerWidth < 768;

  for (const module of modules) {
    const sectionBtns = module.querySelectorAll("header button");
    const panels = module.querySelectorAll(".ingredients-body");
    const body = module.querySelector(".ingredients-body-outer");
    let activeButton = module.querySelector(".btn.active:not(.ingredient-btn)");
    if (!isMobile) body.style.height = `${body.scrollHeight}px`;

    // Change sections
    sectionBtns.forEach((btn, index) => {
      btn.addEventListener("click", () => {
        body.classList.add("sliding");
        isMobile = window.innerWidth < 768;

        body.addEventListener(
          "transitionend",
          (e) => {
            body.classList.remove("sliding");
          },
          { once: true }
        );

        // Slide panels
        body.style.transform = `translateX(${index * -100}vw)`;

        // Change height of module
        const innerList = panels[index].firstElementChild.firstElementChild;
        const innerText = panels[index].querySelector(
          ".ingredient-description.active"
        );
        if (!isMobile) {
          body.style.height = `${
            innerList.scrollHeight > innerText.scrollHeight
              ? innerList.scrollHeight
              : innerText.scrollHeight
          }px`;
        } else {
          body.style.height = `${
            innerList.scrollHeight + innerText.scrollHeight
          }px`;
        }

        // Change active button
        sectionBtns.forEach((b) => b.classList.remove("active"));
        btn.classList.add("active");
      });
    });

    // Change ingredient
    for (const panel of panels) {
      const ingredientBtns = panel.querySelectorAll(".ingredients-list button");
      const ingredientPanels = panel.querySelectorAll(
        ".ingredient-description"
      );

      ingredientBtns.forEach((btn, index) => {
        btn.addEventListener("click", () => {
          const activePanel = ingredientPanels[index];

          isMobile = window.innerWidth < 768;
          // Hide and show panels
          ingredientPanels.forEach((ingredientPanel) =>
            ingredientPanel.classList.remove("active")
          );
          activePanel.classList.add("active");

          // Change active button
          ingredientBtns.forEach((b) => b.classList.remove("active"));
          btn.classList.add("active");

          // Outer elements
          const btnList = btn.closest("ul");

          if (!isMobile) {
            body.style.height =
              btnList.scrollHeight > activePanel.scrollHeight
                ? `${btnList.scrollHeight}px`
                : `${activePanel.scrollHeight}px`;
          } else {
            // Change height of module
            body.style.height = `${
              btnList.scrollHeight + activePanel.scrollHeight
            }px`;
          }
        });
      });
    }

    setTimeout(() => {
      if (activeButton) {
        activeButton.click();
      }
    }, 1);

    window.addEventListener("resize", () => {
      activeButton = module.querySelector(".btn.active:not(.ingredient-btn)");
      if (activeButton) {
        activeButton.click();
      }
    });
    
  }
}
